import * as styles from "./Button.css";
import { ButtonProps } from "./Button";
import { Link as ILink } from "~/sanity/types";
import Link from "./Link";
import { LinkProps } from "@remix-run/react";
import { PropsWithChildren } from "react";
import clsx from "clsx";

export type ButtonLinkProps = ButtonProps & {
  link?: ILink & { slug?: string; to?: LinkProps["to"] };
  className?: string;
  onClick?: () => void;
};

export type InternalButtonLinkProps = PropsWithChildren & ButtonLinkProps;

export const ButtonLink = ({
  isPrimary = true,
  theme = "light",
  icons,
  size = "md",
  children,
  layout = "default",
  link,
  isDisabled,
  className,
  onClick,
  ...props
}: InternalButtonLinkProps) => {
  return (
    <>
      {link ? (
        <Link
          onClick={onClick}
          {...link}
          {...props}
          className={clsx(
            className,
            styles.button({
              theme: theme,
              isPrimary: isPrimary,
              size: size,
              hasChild: children ? true : false,
              isDisabled: isDisabled,
              layout: layout,
            })
          )}
        >
          <div
            className={styles.child({
              hasIcon: icons ? true : false,
              size: size,
              isPrimary: isPrimary,
              layout: layout,
            })}
          >
            {children}
            {icons && (
              <div className={styles.iconsContainer({ size: size })}>
                <div className={styles.icons}>
                  <div className={styles.iconContainer({ size: size })}>
                    <div
                      className={styles.icon({
                        size: size,
                        hasChild: children ? true : false,
                      })}
                    >
                      {icons.iconPrimary}
                    </div>
                  </div>
                  <div className={styles.iconContainer({ size: size })}>
                    <div
                      className={styles.icon({
                        size: size,
                        hasChild: children ? true : false,
                      })}
                    >
                      {icons.iconSecondary || icons.iconPrimary}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Link>
      ) : (
        <div
          {...props}
          className={clsx(
            className,
            styles.button({
              theme: theme,
              isPrimary: isPrimary,
              size: size,
              hasChild: children ? true : false,
              isDisabled: isDisabled,
              layout: layout,
            })
          )}
        >
          <div
            className={styles.child({
              hasIcon: icons ? true : false,
              size: size,
              isPrimary: isPrimary,
              layout: layout,
            })}
          >
            {children}
            {icons && (
              <div className={styles.iconsContainer({ size: size })}>
                <div className={styles.icons}>
                  <div className={styles.iconContainer({ size: size })}>
                    <div
                      className={styles.icon({
                        size: size,
                        hasChild: children ? true : false,
                      })}
                    >
                      {icons.iconPrimary}
                    </div>
                  </div>
                  <div className={styles.iconContainer({ size: size })}>
                    <div
                      className={styles.icon({
                        size: size,
                        hasChild: children ? true : false,
                      })}
                    >
                      {icons.iconSecondary || icons.iconPrimary}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
